import { render } from "./MaintBoard.vue?vue&type=template&id=073b9d14"
import script from "./MaintBoard.vue?vue&type=script&lang=js"
export * from "./MaintBoard.vue?vue&type=script&lang=js"

import "./MaintBoard.vue?vue&type=style&index=0&id=073b9d14&lang=css"

import exportComponent from "/codebuild/output/src2517490718/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__